
















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {i18nAllObject} from '@/utils/i18n';
import {changeDateFormat} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';

@Component({
  components: {CompSelectBox}
})
export default class ItemTable extends Vue {
  @Prop() private option?: any;
  private initOver = false;
  private itemInfo = {
    noBorder: false,
    onLoadSearch: false,
    excelDownInfo: null as any
    
  };

  @Prop({required: true})
  private grid1Props!: any;
  @Prop({required: true})
  private grid2Props!: any;
  @Prop({required: true})
  private data!: [];

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('resetData', this.data as any);
    grid.invoke('setBodyHeight', 33);
    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });

    const grid2 = this.$refs.tuiGrid2 as Grid;
    grid2.invoke('resetData', this.data as any);
    grid2.invoke('setBodyHeight', 32);
    this.$nextTick(() => {
      grid2.invoke('refreshLayout');
    });
  }

  private excelDown() {
    if (this.data && this.data.length > 0) {
      let columns = i18nAllObject(this, this.itemInfo.excelDownInfo.columns);
      let fileName = this.itemInfo.excelDownInfo.fileName;
      if (this.itemInfo.excelDownInfo.nameDateFormat !== undefined) {
        fileName += changeDateFormat(new Date(), this.itemInfo.excelDownInfo.nameDateFormat);
      }
      writeExcel(this.data, columns, fileName, this.itemInfo.excelDownInfo.formatters);
    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }

  private initOption() {
    if (this.option) {
      if (this.option.onLoadSearch !== undefined) {
        this.itemInfo.onLoadSearch = this.option.onLoadSearch;
      }
      if (this.option.excelDownInfo !== undefined) {
        this.itemInfo.excelDownInfo = this.option.excelDownInfo;
      }
    }
    this.initOver = true;
  }

  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;
    const grid2 = this.$refs.tuiGrid2 as Grid;
    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    grid2.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        if (ev.columnName === 'mergeMall') {
          $('th[data-column-name="totalMallAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="totalMallPer"]').removeClass('tui-grid-cell-selected');
        }
        if (ev.columnName === 'mergePartner') {
          $('th[data-column-name="totalPartnerAmt"]').removeClass('tui-grid-cell-selected');
          $('th[data-column-name="totalPartnerPer"]').removeClass('tui-grid-cell-selected');
        }
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }
  }
}
